import React, { useEffect, useState } from 'react';
import { HERO_DURACION as DURACION, heroAvatares as AVATARES, heroSlides as SLIDES } from '../data/contenido';
import { WA_GENERAL } from '../services/whatsapp';
import { grande, micro, mini, scrollToId } from '../utils';
import './Hero.css';

export default function Hero() {
  const [i, setI] = useState(0);
  // Fotos del carrusel: solo se pide la actual y, cuando ya cargó, la siguiente (antes se pedían
  // las 6 a la vez). Las que ya cargaron se quedan montadas para el fundido entre fotos.
  const [cargadas, setCargadas] = useState([]);
  const siguiente = (i + 1) % SLIDES.length;
  const montada = (k) => k === i || cargadas.includes(k) || (k === siguiente && cargadas.includes(i));
  const alCargar = (k) => setCargadas((c) => (c.includes(k) ? c : [...c, k]));

  useEffect(() => {
    const t = setTimeout(() => setI((n) => (n + 1) % SLIDES.length), DURACION);
    return () => clearTimeout(t);
  }, [i]);

  const ir = (id) => (e) => { e.preventDefault(); scrollToId(id); };

  return (
    <section id="inicio" className="hero on-dark">
      <div className="hero__bg" aria-hidden="true">
        {SLIDES.map((s, k) => montada(k) && <img key={s.url} src={micro(s.url)} alt="" className={k === i ? 'is-on' : ''} />)}
      </div>
      <div className="wrap hero__grid">
        <div className="hero__texto">
          <p className="eyebrow">Experiencias by Jenny · Travel Designer</p>
          <h1>El viaje que imaginas, <em>diseñado a&nbsp;tu medida.</em></h1>
          <p className="hero__lead">Soy Jenny Jiménez, agente de viajes certificada por Disney, Universal y CLIA. Te recomiendo lo que conozco en persona y te acompaño antes y durante tu viaje.</p>
          <div className="hero__ctas">
            <a className="btn-wa hero__cta" href={WA_GENERAL} target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp" />Planea tu viaje por WhatsApp</a>
            <a className="hero__ghost" href="#mundo" onClick={ir('mundo')}>Explora mi mundo<i className="fa-solid fa-arrow-down" /></a>
          </div>
          <a className="hero__social" href="#viajeros" onClick={ir('viajeros')}>
            <span className="hero__avs">{AVATARES.map((a) => <img key={a} src={micro(`images/resenas/${a}.webp`)} alt="" />)}</span>
            <span>
              <span className="hero__stars">{[0, 1, 2, 3, 4].map((k) => <i key={k} className="fa-solid fa-star" />)}</span>
              <span className="hero__social-t">Familias que ya viajaron conmigo</span>
            </span>
          </a>
        </div>
        <div className="hero__foto">
          <div className="hero__card">
            {SLIDES.map((s, k) => montada(k) && (
              <img
                key={s.url}
                src={grande(s.url)}
                alt={s.cap}
                className={k === i ? 'is-on' : ''}
                fetchpriority={k === 0 ? 'high' : 'low'}
                decoding="async"
                onLoad={() => alCargar(k)}
              />
            ))}
            <div className="hero__shade" />
            <div className="hero__bars">
              {SLIDES.map((s, k) => (
                <button key={s.url} onClick={() => setI(k)} aria-label={s.cap}>
                  <span><span key={k === i ? `on-${i}` : 'off'} className={k < i ? 'is-full' : k === i ? 'is-run' : ''} style={{ animationDuration: `${DURACION}ms` }} /></span>
                </button>
              ))}
            </div>
            <span className="hero__cap"><i className="fa-solid fa-location-dot" />{SLIDES[i].cap}</span>
          </div>
          <figure className="polaroid hero__jenny">
            <img src={mini('images/hero-bg.jpg')} alt="Jenny" />
            <figcaption>¡Hola, soy Jenny!</figcaption>
          </figure>
        </div>
      </div>
    </section>
  );
}
